import {
  createRouter,
  createWebHistory,
  type RouterScrollBehavior,
  type Router
} from 'vue-router'

import commonRoutes from '@/router/commonRoutes'

const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
  if (to.hash) {
    return { el: to.hash, behavior: 'smooth' }
  }

  return to.path === from.path && savedPosition ? savedPosition : { left: 0, top: 0 }
}

export function buildRouter(): Router {
  return createRouter({
    history: createWebHistory(),
    routes: commonRoutes,
    scrollBehavior
  })
}
